import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@shared/ui/button';

interface Props {
  expanded: boolean;
  hiddenCount: number;
  onToggle: () => void;
}

export const RecentShowMore: React.FC<Props> = ({ expanded, hiddenCount, onToggle }) => {
  const Icon = expanded ? ChevronUp : ChevronDown;
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onToggle}
      aria-expanded={expanded}
      className="w-full justify-center gap-1 text-xs text-muted-foreground"
    >
      <Icon className="h-3.5 w-3.5" />
      {expanded ? 'Show less' : `Show ${hiddenCount} more`}
    </Button>
  );
};
